import { Route, Routes } from "react-router-dom";
import { Sped } from "./list";

export default function SpedRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Sped />} />
    </Routes>
  );
}
